import { css } from 'lit';
import { fsDesignToken } from '../../../core/style-util.js';

export const style = css`
  /* stylelint-disable */
  .header {
    background: linear-gradient(
      ${fsDesignToken('fsColorCoreBlue60')} 80%,
      #ffff 20%
    );
  }

  .inapp-decline-delay-header {
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    font-size: ${fsDesignToken('fsFontSizeMedium3')};
    line-height: 36px;
    color: ${fsDesignToken('fsTextColorPrimary')};
    margin: 0;
  }

  .header-full {
    background: linear-gradient(
      ${fsDesignToken('fsColorCoreBlue60')} 100%,
      #ffff 0%
    );
    padding-bottom: 1rem;
  }
  /* stylelint-enable */

  .header-text {
    color: white;
    font-size: ${fsDesignToken('fsFontSizeLarge1')};
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    line-height: 36px;
    margin-bottom: 1rem;
    margin-top: 0;
  }

  .iconic-container {
    margin-left: auto;
    margin-right: auto;
    max-width: ${fsDesignToken('fsBreakpointMedium')};
    padding: 0 ${fsDesignToken('fsSizeSpacingMedium2')};
  }

  @media (min-width: 768px) {
    .iconic-container {
      max-width: ${fsDesignToken('fsBreakpointMedium')};
      padding: 0;
    }
  }

  @media (min-width: ${fsDesignToken('fsBreakpointExtraLarge')}) {
    .iconic-container {
      max-width: 768px;
    }
  }

  .marketing-offer {
    background-color: ${fsDesignToken('fsColorFeedbackInfoSecondary')};
    border-radius: ${fsDesignToken('fsRadiusMedium')};
    font-size: ${fsDesignToken('fsFontSizeMedium1')};
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    padding: ${fsDesignToken('fsSizeSpacingMedium1')};
  }

  .return-cta {
    margin-top: 1em;
    text-align: center;
  }

  .return-cta-button {
    margin: 0 auto;
  }

  .grid {
    display: grid;
    flex-grow: 1;
    grid-auto-flow: row;
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .grid-multiple {
    @media (min-width: 768px) {
      gap: 1rem;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  .loan__transunion-claim {
    font-size: ${fsDesignToken('fsFontSizeSmall1')};
    font-weight: ${fsDesignToken('fsFontWeightRegular')};
    line-height: ${fsDesignToken('fsFontLineHeightNormal')};
    text-align: center;
  }

  .choose-vehicle__selection-container {
    margin-top: 1em;
    text-align: center;

    .choose-vehicle__selection-search {
      color: ${fsDesignToken('fsTextColorLinkPrimaryDefault')};
      font-size: ${fsDesignToken('fsFontSizeMedium1')};
      font-weight: ${fsDesignToken('fsFontWeightSemibold')};
      line-height: ${fsDesignToken('fsFontLineHeightNormal')};
    }
  }

  .ufo-heading {
    margin-bottom: 8px;
  }
`;
